import { Menu, Stack, Typography } from "@mui/material";
import { T } from "../../util/t";
import { useMenuState } from "hooks/useMenuState";
import { ExpandMore } from "@mui/icons-material";
import { makeStyles } from "components/providers/makeStyles";
import { UnpaidMenuItems } from "./UnpaidMenuItems";

const useStyles = makeStyles({
    status: {
        cursor: "default",
    },
});

export const UnpaidMenu = ({ entry, children }) => {
    const [anchorEl, openMenu, closeMenu] = useMenuState();
    const stopEvent = (e) => e.stopPropagation();
    const classes = useStyles();

    return (
        <Stack
            direction="column"
            alignItems="flex-start"
            spacing={1}
            onClick={stopEvent}
        >
            <div className={classes.status}>{children}</div>

            <Stack
                direction="row"
                alignItems="center"
                color="error.main"
                spacing={1}
                onClick={openMenu}
            >
                <Typography variant="button2">
                    <T>Unpaid</T>
                </Typography>
                <ExpandMore fontSize="small" />
            </Stack>

            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={closeMenu}>
                <UnpaidMenuItems entry={entry} />
            </Menu>
        </Stack>
    );
};
